/* Beans with Benefits – Bohnenrechner. Gehört zu sections/loyalty-club.liquid. Schreibt nur Zahlen und blendet Belohnungen ein.
   Leat rechnet Bohnen pro Euro Warenwert ohne MwSt. und Versand (Stand 13.10.2026: 5 Bohnen pro Euro). Werte kommen aus data-rate, data-vat, data-months. */
(function () {
  'use strict';
  function fmt(n) {
    var lang = (document.documentElement.getAttribute('lang') || 'de').slice(0, 2);
    try { return new Intl.NumberFormat(lang === 'en' ? 'en-GB' : 'de-DE').format(n); } catch (e) { return String(n); }
  }
  function init(calc) {
    if (calc.getAttribute('data-init')) return;
    calc.setAttribute('data-init', '1');
    var rate = parseFloat(calc.getAttribute('data-rate')) || 5;
    var vat = parseFloat(calc.getAttribute('data-vat'));
    if (isNaN(vat) || vat < 0) vat = 0;
    var horizon = parseInt(calc.getAttribute('data-months'), 10) || 6;
    var input = calc.querySelector('[data-loy-spend]');
    var outSpend = calc.querySelector('[data-loy-spend-out]');
    var outBeans = calc.querySelector('[data-loy-beans]');
    var say = calc.querySelector('[data-loy-say]');
    var tOne = calc.querySelector('[data-loy-t-one]');
    var tMany = calc.querySelector('[data-loy-t-many]');
    var rewards = [];
    try { rewards = JSON.parse(calc.querySelector('[data-loy-rewards]').textContent); } catch (e) {}
    rewards = rewards.filter(function (r) { return r.beans > 0; }).sort(function (a, b) { return a.beans - b.beans; });
    var section = calc.closest('.loy');
    var ladder = section ? section.querySelector('.loy-ladder') : null;
    var fill = ladder ? ladder.querySelector('.loy-ladder-fill') : null;
    var max = ladder ? parseFloat(ladder.getAttribute('data-loy-max')) || 0 : 0;
    var cards = ladder ? ladder.querySelectorAll('.loy-reward') : [];
    if (!input || !rewards.length) return;

    function update() {
      var spend = parseInt(input.value, 10) || 0;
      /* Leat: Bohnen pro Euro Warenwert ohne MwSt., abgerundet */
      var perMonth = Math.floor(spend / (1 + vat) * rate);
      outSpend.textContent = spend;
      outBeans.textContent = fmt(perMonth);
      var first = rewards[0];
      var months = perMonth > 0 ? Math.ceil(first.beans / perMonth) : 0;
      if (say && months > 0) {
        var tpl = (months === 1 ? tOne : tMany);
        var txt = tpl ? tpl.innerHTML : '';
        say.textContent = txt.replace('{months}', months).replace('{beans}', fmt(first.beans)).replace('{reward}', first.name);
      }
      var year = perMonth * 12;
      if (fill && max) fill.style.width = Math.min(100, (perMonth * horizon) / max * 100) + '%';
      for (var i = 0; i < cards.length; i++) {
        var b = parseFloat(cards[i].getAttribute('data-beans')) || 0;
        cards[i].classList.toggle('is-reached', b <= perMonth * horizon);
      }
      calc.setAttribute('data-year', year);
    }
    input.addEventListener('input', update);
    update();
  }
  function run() {
    var calcs = document.querySelectorAll('[data-loy-calc]');
    for (var i = 0; i < calcs.length; i++) init(calcs[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', run);
})();
